const MARKETING_GET_PRIMARY_INTERESTS = 'MARKETING_GET_PRIMARY_INTERESTS'
const MARKETING_GET_PRIMARY_INTERESTS_SUCCESS =
  'MARKETING_GET_PRIMARY_INTERESTS_SUCCESS'
const MARKETING_GET_PRIMARY_INTERESTS_ERROR =
  'MARKETING_GET_PRIMARY_INTERESTS_ERROR'

export {
  MARKETING_GET_PRIMARY_INTERESTS,
  MARKETING_GET_PRIMARY_INTERESTS_SUCCESS,
  MARKETING_GET_PRIMARY_INTERESTS_ERROR,
}
